<template>
  <div ref="home" class="home">
      <div v-html="info"></div>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
export default {
  components: { Header, Sidebar, Footer },
  data () {
    return {
      info: []
    }
  },
  methods: {
    getInfo () {
      this.$axios({
        methods: 'get',
        url: '/blog/api/getarticlebyid',
        params: {
          id: this.$route.query.id
        }
      }).then(res => {
        this.info = res.data.content
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.getInfo()
  },
  destroyed () {
  },
  watch: {
    $route: {
      handler (newVal, oldVal) {
        this.getInfo()
      }
    }
  }
}
</script>
<style lang="less" scoped>
// 移动端样式
@media only screen and (max-width: 1024px) {

}
// pc端样式
@media only screen and (min-width: 1024px) {
  .home {
    background: #fff;
    padding-top: 64px;
    max-width: 1180px;
    margin: 0 auto;
    padding-bottom: 149px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/newsInfo.vue